import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp,FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import Logo from './Logo';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import ElmotkadmaWhiteLogo from './ElmotkadmaWhiteLogo';


const Footer = () => {
  const user = useSelector(state => state?.user?.user);
  return (
    <footer className='bg-[#0d1326] text-white'>
      {/* Top Section */}
      <div className='container mx-auto p-8 flex flex-col md:flex-row md:justify-between items-start'>
        
       {/* Section 1: Help */}
      <div className='mb-8 md:mb-0'>
        <h3 className='font-bold mb-4'> DAWACO الاتصال بنا لتلقي المساعدة</h3>
        <ul className='space-y-2'>
          {/* Phone Number */}
          <li className='flex items-center space-x-2'>
            <FaPhoneAlt className='text-lg' />
            
            <span>+218931571358</span>
            <li>اتصل بنا</li>
          </li>


          <li className='flex items-center space-x-2'>
          <a href='https://wa.me/+218931571358' target='_blank' rel='noopener noreferrer' className='flex items-center space-x-2'>
            <FaWhatsapp className='text-2xl' />
            <span>او قم بمراسلتنا عن طريق الضغط هنا</span>
          </a>
        </li>


          
          {/* Email */}
          <li className='flex items-center space-x-2'>
            <FaEnvelope className='text-lg' />
            <a href='mailto:dawaco.services@gmail.com' className='hover:underline'>
            dawaco.services@gmail.com
            </a>
          </li>
        </ul>
      </div>
       {/* Section 1: Help */}
       {/* 
       <div className='mb-8 md:mb-0'>
        <h3 className='font-bold mb-4'> ALMOTAKADEMA الاتصال بنا لتلقي المساعدة</h3>
        <ul className='space-y-2'>
          {/* Phone Number 
          <li className='flex items-center space-x-2'>
            <FaPhoneAlt className='text-lg' />
            
            <span>+218917053311</span>
            <li>اتصل بنا</li>
          </li>


          <li className='flex items-center space-x-2'>
          <a href='https://wa.me/+218917053311' target='_blank' rel='noopener noreferrer' className='flex items-center space-x-2'>
            <FaWhatsapp className='text-2xl' />
            <span>او قم بمراسلتنا عن طريق الضغط هنا</span>
          </a>
        </li>


          
          {/* Email 
          <li className='flex items-center space-x-2'>
            <FaEnvelope className='text-lg' />
            <a href='mailto:almotakadema.dawaco@gmail.com' className='hover:underline'>
            almotakadema.dawaco@gmail.com
            </a>
          </li>
        </ul>
      </div>
      */}

        {/* Section 2: Legal */}
        <div className='mb-8 md:mb-0'>
          <h3 className='font-bold mb-4'>قانوني</h3>
          <ul className='space-y-2'>
            <li>الشروط والأحكام</li>
            <li>الخصوصية</li>
            <li>سياسة الاسترجاع</li>
          </ul>
        </div>

        {/* Section 3: Help */}
        {user?._id && user?.role!==ROLE.SALESMAN && (
        <div className='mb-8 md:mb-0'>
          <h3 className='font-bold mb-4'>اكتشف</h3>
          <ul className='space-y-2'>
         
          <Link to={"/"}> <li className='mt-2'> منتجات حديثة الوصول</li> </Link>

          <Link to={"/"}>  <li className='mt-2'>العروض المجمعة</li></Link>
          
          <Link to={"/"}>  <li className='mt-2'>التخفيضات</li></Link>
           
          </ul>
        </div>
        )}

        {/* Section 4: Logo and Social Icons */}
        <div className="flex items-center space-x-2 md:space-x-4">
        <Link to={"/"}>
    {/* Set smaller size for mobile, larger for desktop */}
    <Logo className="w-16 h-16 md:w-36 md:h-36" w={130} h={130} />
  </Link>
  {/*
  <Link to={"/"}>
    {/* Set smaller size for mobile, larger for desktop 
    <ElmotkadmaWhiteLogo className="w-16 h-16 md:w-36 md:h-36" w={130} h={130} />
  </Link>
  */}

          
          {/* Social Icons */}
          <div className='flex space-x-4 text-4xl mt-4 ml-[40px] '>
     {  /*  <a href='https://www.facebook.com' target='_blank' rel='noopener noreferrer'>
              <FaFacebookF />
            </a>
            <a href='https://www.instagram.com' target='_blank' rel='noopener noreferrer'>
              <FaInstagram />
            </a>
            <a href='https://www.youtube.com' target='_blank' rel='noopener noreferrer'>
              <FaYoutube />
            </a>
                        <a href='https://wa.me' target='_blank' rel='noopener noreferrer'>
              <FaWhatsapp />
            </a>
        */}




          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className='bg-[#0d1326] py-4'>
        <div className='container mx-auto flex justify-center'>
          <p className='text-center text-sm'>© 2024 DAWACO . All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
